<template>
    <div class="m-viewport" id="mainView">

        <div class="logo-view">
          <h2 class="logo_1"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>        

        <loading v-show="Loading"/>
       
        <div class="page-body" :class="$route.name" v-if="ready">
            <user-info class="m-user text-overflow-1"/>

            <div class="page-wrapper">
                <transition name="fade" mode="out-in" appear>
                    <router-view v-if="isRouterAlive" class="router"></router-view>
                </transition>     
            </div>
        </div>

        <div class="u-page-nav flex-between-center" :class="{'ios' : $global.isIos , 'kd' : KD.isApp()}">
            <router-link 
            v-for="(item,index) in router_mainfest" 
            :key = index
            v-bind:to="item.link" 
            class="nav-item"
            :class="[item.name , 'n-' + (index + 1)]" 
            active-class="act">
            {{item.title}}
            </router-link>    
            <div class="nav-item u-btn n-3" @click="$rule_modal()"></div>
        </div>

    </div>
</template>

<script>
import {mapState} from 'vuex'
import loading from '@/components/loading.vue'
import KD from '@/assets/js/kd.js';

export default {
    components: {
        loading,
    },     
    data() {
        return {
            isRouterAlive : true,
            router_mainfest : [
                {name : 'box',link : '/index'},               
                {name : 'team',link : '/team'},
            ],
            ios : /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent),
            KD,                                     
        }
    },
    provide () {
        return {
            reload: this.reload
        }
    },          
    computed : {
        ...mapState(['Loading'])
    },  
    props : {
        ready : {
            default : false,
        },
    },
    methods: {
        reload () {
            this.isRouterAlive = false
            this.$nextTick(function () {
                this.isRouterAlive = true
            })
        }    
    }        
}
</script>

<style lang="scss">
.m-viewport{
    position: relative;
    width: 750px;
    margin: 0 auto 0;
    background-repeat: no-repeat;
    background-position: top center;
    box-sizing: border-box;
    font-size: 24px;
    background-color: #341e0d;
    color: #202722;
    overflow-x: hidden;
    overflow-y: hidden;
    /* overflow-y: scroll;    */
    font-family: "HYJinKaiJ";
}

.video{
    position: relative;
    left: 50%;
    top: 0;
    transform: translate(-50%,0);
    width: 1920px;
    height: 1080px;
    margin: 0 auto;
}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;
    left: 2%;
    top:30px;
    z-index: 3;
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.logo-view .logo_1{
    width: 124px;
    height: 98px;
    background-image: url(~@/assets/images/logo.png);
}

.page-body{
    position: relative;
    width: 100%;
    height: 6072px;
    padding-top: 980px;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: hidden;
    background-image: url(~@/assets/images/body.jpg);
    
    &.index{
        height: 5072px;
        background-image: url(~@/assets/images/body_index.webp);
    }

    &.team{
        height: 5448px;
        background-image: url(~@/assets/images/body_team.webp);
    }
}

.page-wrapper{
    // width: 730px;
    margin: 20px auto 0;

    .icon-warn{
        display: inline-block;
        width: 23px;
        height: 24px;
        //background-image: url(~@/assets/images/icon-warn.png);
        vertical-align: middle; 
    }    
}

.m-user{
    //background-image: url(~@/assets/images/pc/bg-userinfo.png);   

    .u-btn.login{
        color: #d34919;
    }
}

.u-page-nav{
    position: fixed;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 750px;
    height: 90px;
    z-index: 12;
    background-color: rgba($color: #200b00, $alpha: 0.7);

    &.ios.kd{
        bottom: 40px;
    }

    .nav-item{
        width: 248px;
        height: 91px;

        @for $i from 1 through 3{
            &.n-#{$i}{
                background-image: url(~@/assets/images/nav/#{$i}.png);

                &.act{
                    background-image: url(~@/assets/images/nav/#{$i}D.png);
                }
            }
        }        
    }
}
</style>